(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cart-drawer"] && !Shopify.designMode) return;
  try {
    // Delegation also handles markup refreshed by Shopify's Section Rendering API.
  if (!window.teCartBoxesInstalled) {
    window.teCartBoxesInstalled = true;
    let busy = false;
    document.addEventListener('click', async (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-te-box-add]') : null;
      if (!button || !button.closest('#cart-drawer')) return;
      event.preventDefault();
      if (busy || button.disabled) return;
      busy = true;
      const drawer = button.closest('#cart-drawer');
      const panel = button.closest('[data-te-cart-boxes]');
      const status = panel.querySelector('[data-te-box-status]');
      const buttons = [...panel.querySelectorAll('[data-te-box-add]')];
      const originalText = button.textContent;
      const root = window.Shopify?.routes?.root || '/';
      let deferred;
      let sent = false;
      let added = false;
      let definiteRejection = false;
      let keepDisabled = false;
      buttons.forEach(item => { item.disabled = true; });
      button.textContent = 'Ekleniyor…';
      status.hidden = true;
      drawer.setAttribute('data-te-box-busy', '');
      panel.setAttribute('aria-busy', 'true');
      const locked = [...drawer.querySelectorAll('.cart-drawer__summary, .cart-items__quantity-controls')];
      const inertBefore = locked.map(item => item.inert);
      locked.forEach(item => { item.inert = true; });
      try {
        const { CartLinesUpdateEvent } = await import('@shopify/events');
        deferred = CartLinesUpdateEvent.createPromise();
        // Attach a rejection handler even if the theme components are not ready yet.
        deferred.promise.catch(() => {});
        const sections = [...new Set(['cart-drawer-section', ...Array.from(document.querySelectorAll('cart-items-component[data-section-id]'), item => item.dataset.sectionId)])].slice(0, 5);
        button.dispatchEvent(new CartLinesUpdateEvent({
          action: 'add', context: 'cart',
          lines: [{ merchandiseId: button.dataset.teBoxAdd, quantity: 1 }],
          promise: deferred.promise
        }));
        sent = true;
        const response = await fetch(root + 'cart/add.js', {
          method: 'POST', credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: button.dataset.teBoxAdd, quantity: 1 }], sections, sections_url: window.location.pathname })
        });
        const result = await response.json();
        if (!response.ok || result.status) {
          definiteRejection = response.status >= 400 && response.status < 500;
          throw new Error(result.description || result.message || 'Kutu sepete eklenemedi.');
        }
        added = true;
        const cartResponse = await fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) throw new Error('Sepet bilgisi yenilenemedi.');
        const cart = await cartResponse.json();
        deferred.resolve({
          cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
          detail: { sections: result.sections, items: cart.items, itemCount: cart.item_count, source: 'tesbihevim-cart-boxes', didError: false }
        });
        // The theme hydrates the drawer, refreshes the total and the cart badge.
        button.textContent = 'Eklendi ✓';
        keepDisabled = true;
      } catch (error) {
        deferred?.reject(error);
        keepDisabled = sent && !definiteRejection;
        status.hidden = false;
        status.textContent = added
          ? 'Kutu eklendi ancak sepet görünümü yenilenemedi. '
          : keepDisabled
            ? 'İşlem sonucu doğrulanamadı. Tekrar eklemeden önce sepetinizi kontrol edin. '
            : (error.message || 'İşlem tamamlanamadı. Lütfen tekrar deneyin.');
        if (keepDisabled) {
          const link = document.createElement('a');
          link.href = root + 'cart';
          link.textContent = 'Sepeti kontrol et';
          status.append(link);
        }
        button.textContent = added ? 'Eklendi ✓' : originalText;
      } finally {
        busy = false;
        drawer.removeAttribute('data-te-box-busy');
        panel.removeAttribute('aria-busy');
        locked.forEach((item, index) => { item.inert = inertBefore[index]; });
        // A refreshed summary might retain inert during hydration.
        drawer.querySelectorAll('.cart-drawer__summary, .cart-items__quantity-controls').forEach(item => {
          if (!locked.includes(item)) item.inert = false;
        });
        if (!keepDisabled) buttons.forEach(item => { item.disabled = false; });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
